export default "__VITE_ASSET__07657880__"